import { fireUtagEvent } from '@garmin/support-analytics';

export default {
  name: 'ScAccordion',
  props: {
    cta: {
      type: String,
      required: true,
    },
    gaEventString: {
      type: String,
      default: '',
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: this.expanded,
    };
  },
  computed: {
    id() {
      return Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));
    },
  },
  methods: {
    onCtaClick() {
      if (this.gaEventString) fireUtagEvent(this.gaEventString);
      this.isExpanded = !this.isExpanded;
    },
  },
};
